import Immutable from 'seamless-immutable';
import { RESET_CUSTOMER_RECOVERABLE } from '../actions/customer.actions';
import * as Actions from '../../components/customer/orderHistory/orderDetails/revokeGiftOrderDialog/revoke.gift.order.actions';
export var INITIAL_STATE = Immutable({
  model: {
    reasonCode: null
  },
  isRevokingGiftOrder: false,
  revokeGiftOrderError: null
});
export default function Reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case Actions.SET_REVOKE_GIFT_ORDER_MODEL:
      return state.merge({
        model: {
          reasonCode: payload.model.reasonCode
        }
      });
    case Actions.REVOKE_GIFT_ORDER_CONSTANTS.BEGIN:
      return state.merge({
        isRevokingGiftOrder: true
      });
    case Actions.REVOKE_GIFT_ORDER_CONSTANTS.SUCCESS:
      return state.merge({
        isRevokingGiftOrder: false,
        revokeGiftOrderError: null
      });
    case Actions.REVOKE_GIFT_ORDER_CONSTANTS.FAILURE:
      return state.merge({
        isRevokingGiftOrder: false,
        revokeGiftOrderError: {
          code: payload.Code,
          message: payload.translatedMessage,
          severity: payload.Severity
        }
      });
    case RESET_CUSTOMER_RECOVERABLE:
      return INITIAL_STATE;
    default:
      return state;
  }
}